import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionTierInterface, SubscriptionTiersService } from '@galaxy/partner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { LevelBadgeStoreService } from './level-badge-store.service';

@Component({
  selector: 'app-level-badge',
  templateUrl: './level-badge.component.html',
  styleUrls: ['./level-badge.component.scss'],
  standalone: false,
})
export class LevelBadgeComponent {
  subscriptionTier$: Observable<SubscriptionTierInterface>;
  subscriptionLevel$: Observable<string>;
  showBadge$: Observable<boolean>;

  constructor(
    private badgeStore: LevelBadgeStoreService,
    private readonly appConfigService: AppConfigService,
    private router: Router,
  ) {
    this.subscriptionTier$ = this.badgeStore.subscriptionTier$;
    this.subscriptionLevel$ = this.badgeStore.subscriptionTier$.pipe(
      map((s) => SubscriptionTiersService.getI18NName(s.id)),
    );
    this.showBadge$ = this.badgeStore.showBadge$;
  }

  handleOnSubLevelClick(_subscriptionTier: SubscriptionTierInterface): void {
    this.router.navigateByUrl('/subscription-tier/my-plan');
  }

  canNavigateToMyPlanPage$(s: SubscriptionTierInterface): Observable<boolean> {
    return this.appConfigService.config$.pipe(
      map((config) => {
        return (
          (SubscriptionTiersService.isVBP2Subscription(s) ||
            SubscriptionTiersService.isM3Subscription(s) ||
            SubscriptionTiersService.isVBP2022Subscription(s) ||
            SubscriptionTiersService.isFree(s)) &&
          config.userCanAccessBilling
        );
      }),
    );
  }
}
